import React from 'react';
import { FilerTranslateItem } from '.';
import FilterItemCell from './FilterItemCell';
import { replaceAllComplex } from '../../../../../../mol_function';

interface FilterItemProps {
  fti: FilerTranslateItem;
  filterPosibleValules: any;
  filterValue?: string;
  updateFilter: (
    fti: FilerTranslateItem,
    newFilterValue: string,
    historyHandle: any,
  ) => void;
  filterOpen: () => void;
  isMobileMenu: boolean;
  fip_index: string;
}

interface FilterItemState {
  isOpen: boolean;
  isMounted: boolean;
}

export default class FilterItem extends React.Component<
  FilterItemProps,
  FilterItemState
> {
  filterMenuRef: any;
  filterItemRef: any;
  eventHandeln: boolean;

  constructor(props: FilterItemProps) {
    super(props);
    this.filterItemRef = React.createRef();
    this.filterMenuRef = React.createRef();
    this.state = { isOpen: false, isMounted: false };
    this.eventHandeln = false;
  }
  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    let filterPrefix = 'fqZZZ';
    if (this.props.fti.fieldPrefix != undefined) {
      filterPrefix = this.props.fti.fieldPrefix;
    }

    let filterKey = filterPrefix + this.props.fti.field;

    let hasFilterValue = this.props.filterValue != undefined;

    let mobileFilterDesc = null;

    let radioMode = this.props.fti.mode == 'radio';

    let replaceArray: { s: string; r: string }[] = [
      { s: '+', r: ' ' },
      { s: '___', r: '/' },
    ];

    if (this.props.isMobileMenu && this.props.filterValue != undefined) {
      mobileFilterDesc = (
        <React.Fragment>
          <br />
          {this.props.filterValue
            .split('|')
            .map((item, index) => {
              let textvalue = item;
              if (radioMode) {
                let tmp = this.props;
                let posibleValues = this.props.filterPosibleValules;
                let found = false;
                let posibleValuesKeys = Object.keys(posibleValues);

                for (let i = 0; !found && i < posibleValuesKeys.length; i++) {
                  if (posibleValues[posibleValuesKeys[i]].key == item) {
                    textvalue = posibleValuesKeys[i];
                    found = true;
                  }
                }
              }
              textvalue = replaceAllComplex(textvalue, replaceArray);
              return <span>{textvalue}</span>;
            })
            .reduce((prev, curr) => {
              return (
                <React.Fragment>
                  {prev}, {curr}
                </React.Fragment>
              );
            })}
        </React.Fragment>
      );
    }

    let filterKeys = Object.keys(this.props.filterPosibleValules);
    let sort = this.props.fti.sort;
    let sortModify = 1;
    if (sort?.startsWith('desc_')) {
      sortModify = -1;
      sort = sort.substring(5);
    }
    if (sort == 'index' || sort == 'count') {
      filterKeys = filterKeys.sort((a: any, b: any) => {
        if (sort == 'index') {
          return this.sortIndex(a, b, sortModify);
        } else {
          let countA = this.props.filterPosibleValules[a].result_count;
          let countB = this.props.filterPosibleValules[b].result_count;
          if (countB - countA != 0) return (countB - countA) * sortModify;
          else {
            return this.sortIndex(a, b, sortModify);
          }
        }
      });
    }

    let captionText = replaceAllComplex(this.props.fti.caption, [
      { s: '&auml;', r: 'ä' },
    ]);

    return (
      <div
        className={this.state.isOpen ? 'filterItem activ' : 'filterItem'}
        ref={this.filterItemRef}
      >
        <div
          className={hasFilterValue ? 'li hasValue' : 'li'}
          onClick={(e) => this.tootleMenu(e)}
        >
          <a className="filterTitle">{captionText}</a>
          {mobileFilterDesc}
        </div>
        <div className="filterItemCopy" onClick={(e) => this.tootleMenu(e)}>
          {captionText}
        </div>
        <div
          ref={this.filterMenuRef}
          className={this.state.isOpen ? 'filterMenu' : 'filterMenu notActive'}
          onClick={(e) => this.filterMenuClick(e)}
        >
          {filterKeys.map((item, index) => {
            let name = item.trim();
            if (name != '') {
              let itemsCount =
                this.props.filterPosibleValules[item].result_count;

              let thisKey = null;

              let isSelected = false;
              if (radioMode) {
                let filterValue = this.props.filterValue;
                if (filterValue == undefined) filterValue = null;
                thisKey = this.props.filterPosibleValules[item].key;
                isSelected = thisKey == filterValue;
              } else {
                if (this.props.filterValue != undefined) {
                  let splitValues: string[] = this.props.filterValue.split('|');
                  for (let i = 0; !isSelected && i < splitValues.length; i++) {
                    let splitValue = replaceAllComplex(
                      splitValues[i],
                      replaceArray,
                    );
                    if (splitValue == name) {
                      isSelected = true;
                    }
                  }
                }
              }

              return (
                <FilterItemCell
                  key={'FilterItemCell' + this.props.fip_index + '_' + index}
                  name={name}
                  itemsCount={itemsCount}
                  isSelected={isSelected}
                  radioMode={radioMode}
                  filterKey={filterKey}
                  filterValue={thisKey != null ? thisKey : undefined}
                  updateHandler={(
                    name: string,
                    newValue: boolean,
                    historyHandle: any,
                  ) => {
                    let newFilterValue = '';
                    if (radioMode) {
                      newFilterValue = name;
                    } else {
                      if (newValue)
                        if (this.props.filterValue == undefined)
                          newFilterValue = name;
                        else
                          newFilterValue = this.props.filterValue + '|' + name;
                      else {
                        let oldArray = this.props.filterValue!.split('|');
                        let index = oldArray.indexOf(name);
                        //oldArray = newArray.splice(index, 1);
                        let newArray = [];
                        for (let i = 0; i < oldArray.length; i++) {
                          if (i != index) newArray.push(oldArray[i]);
                        }
                        newFilterValue = newArray.join('|');
                      }
                    }
                    //$filtervalue = str_replace(array('___', '_-_', '%3F', '0_0', '%27', "'", '-vpv-'),
                    //                           array('/',   '&',   '?',   '!',   "'",   "\'", '+'), $filterSplitItemValue);
                    newFilterValue = replaceAllComplex(newFilterValue, [
                      { s: '/', r: '___' },
                      { s: '&', r: '_-_' },
                      { s: '%3F', r: '?' },
                      { s: '!', r: '0_0' },
                      { s: "'", r: '%27' },
                      { s: '-vpv-', r: '+' },
                    ]);
                    this.props.updateFilter(
                      this.props.fti,
                      newFilterValue,
                      historyHandle,
                    );
                  }}
                ></FilterItemCell>
              );
            }
          })}
        </div>
      </div>
    );
  }

  sortIndex(a: any, b: any, sortModify: number) {
    if (
      !isNaN(parseFloat(a)) &&
      isFinite(a) &&
      !isNaN(parseFloat(b)) &&
      isFinite(b)
    ) {
      return (a - b) * sortModify;
    } else {
      let nameA = a.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      let nameB = b.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      if (nameA < nameB) {
        return -1 * sortModify;
      }
      if (nameA > nameB) {
        return 1 * sortModify;
      }
      return 0;
    }
  }

  tootleMenu(e: any) {
    if (!this.state.isOpen) {
      this.openMenu();
    } else this.closeMenu();

    e.preventDefault();
    e.cancelBubble = true;
    this.eventHandeln = true;
    return false;
  }

  windowClick(e) {
    if (!this.eventHandeln) {
      this.closeMenu();
    }
    this.eventHandeln = false;
  }

  windowClickHandler(e) {
    if (window.OpenFilter != null) {
      let _this = window.OpenFilter;
      _this.windowClick(e);
    }
    //this.windowClick(e);
  }

  openMenu() {
    this.props.filterOpen();
    //this.filterItemRef.current.className = "filterItem activ";
    //this.filterMenuRef.current.className = "filterMenu";
    this.setState({ isOpen: true });
    window.OpenFilter = this;
    window.addEventListener('click', this.windowClickHandler);
  }

  closeMenu() {
    //this.filterItemRef.current.className = "filterItem";
    //this.filterMenuRef.current.className = "filterMenu notActive";
    if (this.state.isMounted) {
      this.setState({ isOpen: false });
      window.OpenFilter = null;
      window.removeEventListener('click', this.windowClickHandler);
    }
  }

  filterMenuClick(e) {
    this.eventHandeln = true;
    e.preventDefault();
    return false;
  }
}
